import { render, staticRenderFns } from "./MonthAllowancesPlansTable.vue?vue&type=template&id=5db3ddda&"
import script from "./MonthAllowancesPlansTable.vue?vue&type=script&lang=js&"
export * from "./MonthAllowancesPlansTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports